import { request } from "../../httpClient";

export const getVehicleRequest = async (id) => {
  const res = await request({
    path: `vehicle/get-data?id=${id}`,
  });
  return res;
};
